import React, { FC } from 'react';

import { TabProps } from '../tab.types';
import { Typography } from '../../../../../../components';
import classNames from 'classnames';
import styles from './chart.module.scss';

/**
 * Exclusively Chart component for Tab
 * @description Chart tab
 *
 * @author Rostyslav Nahornyi
 * @category Components
 * @param { TabProps } props - TabProps defined in the '../tab-props.types.ts'
 */
const Chart: FC<TabProps> = ({ label, isSelected, disabled, className, style, onClick }) => (
  <button
    tabIndex={0}
    aria-label={'button'}
    type={'button'}
    disabled={disabled}
    className={classNames(styles.chartTab, isSelected && styles.selected, className)}
    style={style}
    onClick={onClick}
  >
    <Typography.Text variant={'label4'} className={styles.title}>
      {label}
    </Typography.Text>
  </button>
);

export { Chart };
